import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const contentStyle = css`
	display: flex;
	flex-direction: row;
`;

export const CloseButtonWrapper = styled.div`
	width: 15px;
	height: 15px;
	margin-left: 10px;
	margin-top: 5px;
	cursor: pointer;
	display: flex;
	align-items: center;
`;
